import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import {
  selectBMIMeasurementModalHistoricList,
  selectDistanceMeasurementModalHistoricList,
  selectHeartRateMeasurementModalHistoricList,
  selectHeightMeasurementModalHistoricList,
  selectSaturationMeasurementModalHistoricList,
  selectStepsMeasurementModalHistoricList,
  selectWeightMeasurementModalHistoricList,
  selectBloodGlucoseMeasurementModalHistoricList,
} from '../../../redux/profiles/patientHealthboard/selectors';
import { DATA_SOURCE_TYPE, VITALS_ACTIVITY_TYPE } from '../constants';
import { adaptResponse } from '../utils';

const {
  SATURATION,
  STEPS,
  DISTANCE,
  BMI,
  WEIGHT,
  HEIGHT,
  HEART_RATE,
  BLOOD_GLUCOSE,
} = VITALS_ACTIVITY_TYPE;
const { DEVICES, CCD, ALL_SOURCES } = DATA_SOURCE_TYPE;

export function useAllDataForHistoricListOneDay(dataType) {
  const [historicSourceType, setHistoricSourceType] = useState(ALL_SOURCES);
  const concatData = [];
  const heartRateEntityOneDay = adaptResponse(
    useSelector(selectHeartRateMeasurementModalHistoricList),
  );
  const saturationEntityOneDay = adaptResponse(
    useSelector(selectSaturationMeasurementModalHistoricList),
  );
  const stepsEntityOneDay = adaptResponse(
    useSelector(selectStepsMeasurementModalHistoricList),
  );
  const distanceEntityOneDay = adaptResponse(
    useSelector(selectDistanceMeasurementModalHistoricList),
  );
  const weightEntityOneDay = adaptResponse(
    useSelector(selectWeightMeasurementModalHistoricList),
  );
  const bmiEntityOneDay = adaptResponse(
    useSelector(selectBMIMeasurementModalHistoricList),
  );
  const heightEntityOneDay = adaptResponse(
    useSelector(selectHeightMeasurementModalHistoricList),
  );
  const bloodGlucoseEntityOneDay = adaptResponse(
    useSelector(selectBloodGlucoseMeasurementModalHistoricList),
  );

  const getEntityData = useMemo(
    () => () => {
      switch (dataType) {
        case STEPS:
          return stepsEntityOneDay;
        case DISTANCE:
          return distanceEntityOneDay;
        case BMI:
          return bmiEntityOneDay;
        case WEIGHT:
          return weightEntityOneDay;
        case HEIGHT:
          return heightEntityOneDay;
        case SATURATION:
          return saturationEntityOneDay;
        case HEART_RATE:
          return heartRateEntityOneDay;
        case BLOOD_GLUCOSE:
          return bloodGlucoseEntityOneDay;
        default:
          return [];
      }
    },
    [
      dataType,
      stepsEntityOneDay,
      distanceEntityOneDay,
      bmiEntityOneDay,
      weightEntityOneDay,
      heightEntityOneDay,
      saturationEntityOneDay,
      heartRateEntityOneDay,
      bloodGlucoseEntityOneDay,
    ],
  );

  getEntityData().forEach(({ measurements }) => {
    if (measurements.length > 0) {
      measurements.forEach(entity => {
        if (
          moment(measurements[0].measuredAt, 'YYYY-MM-DD').isSame(
            entity.measuredAt,
            'day',
          )
        ) {
          concatData.push(entity);
        }
      });
    }
  });

  if (CCD === historicSourceType) {
    return {
      setHistoricSourceType,
      dataHistoricForOneDay: concatData
        .filter(({ providerCode }) => {
          return providerCode === CCD;
        })
        .reverse(),
    };
  }

  if (DEVICES === historicSourceType) {
    return {
      setHistoricSourceType,
      dataHistoricForOneDay: concatData
        .filter(({ providerCode }) => {
          return providerCode === DEVICES;
        })
        .reverse(),
    };
  }

  return {
    setHistoricSourceType,
    dataHistoricForOneDay: concatData.sort(
      (a, b) => new Date(b.measuredAt) - new Date(a.measuredAt),
    ),
  };
}



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/SingleDayGrafModal/useAllDataForHistoricListOneDay.jsx